import {getDate, getMonth, getYear} from 'date-fns';
import {match, Pattern} from 'ts-pattern';

import {parseDate} from 'shared/web';

// Printed periods use the compact numeric notation requested for these reports.
export function formatReportDocumentDate(value: string, includeYear = true) {
  const date = parseDate(value);
  const dayMonth = `${getDate(date)}.${getMonth(date) + 1}.`;
  return includeYear ? `${dayMonth}${getYear(date)}` : dayMonth;
}

export function formatReportDocumentPeriod(
  from: string | undefined,
  to: string | undefined,
  allLabel: string
) {
  const nonEmptyDate = Pattern.string.minLength(1);
  return match({from, to})
    .with({from: nonEmptyDate, to: nonEmptyDate}, ({from, to}) => {
      if (from === to) {
        return formatReportDocumentDate(from);
      }
      const sameYear = getYear(parseDate(from)) === getYear(parseDate(to));
      return `${formatReportDocumentDate(from, !sameYear)}-${formatReportDocumentDate(to)}`;
    })
    .with({from: nonEmptyDate}, ({from}) => `${formatReportDocumentDate(from)}-${allLabel}`)
    .with({to: nonEmptyDate}, ({to}) => `${allLabel}-${formatReportDocumentDate(to)}`)
    .otherwise(() => allLabel);
}
